// src/components/layout/BottomNav.js
// Navigation inférieure fixe style app native - NE PAS MODIFIER

import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ROUTES from '../../constants/routes';

const BottomNav = () => {
  const { t } = useTranslation();

  const navItems = [
    { path: ROUTES.HOME, icon: '🏠', labelKey: 'nav.explorer' },
    { path: ROUTES.FAVORITES, icon: '❤️', labelKey: 'nav.favorites' },
    { path: ROUTES.RESERVATIONS, icon: '🧳', labelKey: 'nav.voyages' },
    { path: ROUTES.MESSAGES, icon: '💬', labelKey: 'nav.messages' },
    { path: ROUTES.PROFILE, icon: '👤', labelKey: 'nav.profile' },
  ];

  const styles = {
    nav: {
      position: 'fixed',
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      width: '100%',
      maxWidth: '480px',
      height: '64px',
      backgroundColor: '#0A0E1A',
      borderTop: '1px solid rgba(255, 255, 255, 0.1)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
      zIndex: 99,
      paddingBottom: 'env(safe-area-inset-bottom, 0px)',
    },
    navItem: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '4px',
      textDecoration: 'none',
      color: '#4A5568',
      transition: 'color 250ms ease-in-out',
      minWidth: '48px',
      minHeight: '48px',
      padding: '8px',
    },
    navItemActive: {
      color: '#FFD700',
    },
    icon: {
      fontSize: '20px',
      lineHeight: '1',
    },
    label: {
      fontSize: '10px',
      fontWeight: '500',
      lineHeight: '1',
    },
  };

  return (
    <nav style={styles.nav}>
      {navItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          style={({ isActive }) => ({
            ...styles.navItem,
            ...(isActive ? styles.navItemActive : {}),
          })}
        >
          <span style={styles.icon}>{item.icon}</span>
          <span style={styles.label}>{t(item.labelKey)}</span>
        </NavLink>
      ))}
    </nav>
  );
};

export default BottomNav;